import React, { useState, useEffect, useLayoutEffect } from 'react'
import styled, { css } from 'styled-components'
import { useSelector, useDispatch, batch } from 'react-redux';
import { ReportList } from './ReportList'
import { Settings } from './Settings'
import { HeaderBar } from './HeaderBar'
import { GenerateReport } from './GenerateReport'
import { getReports } from '../../api/report'
import FadeLoader from "react-spinners/FadeLoader";
import { Icon } from '@iconify/react';
import bxDownload from '@iconify/icons-bx/bx-download';


import { selectAllReportSchedules, fetchReportSchedules, toggleActive } from '../../store/data-export/reportSchedulesSlice';
import { selectCustomer, editCustomer, fetchCustomer } from '../../store/data-export/customersSlice';
import { selectAllReports, fetchReports } from '../../store/data-export/reportsSlice';
import { selectAllReportTemplates } from '../../store/data-export/reportTemplatesSlice';

import { fetchAllReportData } from '../../store/data-export/report'

const Dialog = styled.div<{ display: boolean }>`
  position: fixed;
  top: 50%;
  left: 50%;
  -ms-transform: translateY(-50%) translateX(-50%);
  transform: translateY(-50%) translateX(-50%);
  width: 1000px;
  height: 680px;
  background: #EEEEEE;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25);
  display: ${props => props.display? 'block' : 'none'};
`;

const Content = styled.div`
  width: 100%;
  height: 500px;
  display: flex;
`;

const Main = styled.div`
  width: 700px;
  margin: 5px 10px 10px 20px;
  height: 605px;
  display: flex;
  flex-direction: column;
  position: relative;
  border: 1px solid #ddd;
`;

const spinner = css`
  position: absolute;
  top: 50%;
  left: 50%;
`;

const Disabled = styled.div`
  color: #333;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translateY(-50%) translateX(-50%);
  transform: translateY(-50%) translateX(-50%);
`;

const StyledMessage = styled.div`
  position: relative; 
  width: 240px;
  height: 605px;
  color: #333;
  padding: 250px 10px;
  text-align: center;
`;

const DownloadIcon = styled(Icon)`
  color: #555;
  padding: 0 5px;
  margin-bottom: -7px;
  position: relative;
`;

export function ReportModal ({ users, station, site, display, report_read_only }: { users: any, station: any; site: number, display: boolean, report_read_only: boolean }) {
  
  const dispatch = useDispatch();
  const scheduled_reports = useSelector(selectAllReportSchedules);
  const scheduled_report = scheduled_reports[scheduled_reports.length - 1];

  const reports = useSelector(selectAllReports) || [];
  const report_templates = useSelector(selectAllReportTemplates) || []
  const customer = useSelector(selectCustomer);
  
  const templates = [{ id: 1, name: 'Default Daily' }, { id: 2, name: 'Default Weekly' }]
  
  useLayoutEffect(() => {
    dispatch(fetchAllReportData(station.id, site))
  }, []);

  return (
    <Dialog display={display}>
      <HeaderBar scheduled_report={scheduled_report}/>
      {station !== null && site !== null && typeof customer !== 'undefined' && scheduled_reports.length > 0?
        typeof scheduled_report !== 'undefined' && (scheduled_report.active == 1 || scheduled_report.active == 0)?
          <Content>
            <Main>
              <ReportList templates={report_templates} reports={reports} station={station}/>
              {!report_read_only ?
              <GenerateReport scheduled_report={scheduled_report}/>
              : null }
            </Main>
            {report_read_only ?
            <StyledMessage>Click on the <DownloadIcon align='middle' width='30px' height='30px' icon={bxDownload}/> icon to download the report</StyledMessage>    
            : users.length > 0 ? 
              <Settings templates={report_templates} customer={customer} users={users} scheduled_report={scheduled_report} onCustomerChange={(customer)=>{dispatch(editCustomer(customer))}}/>
              : <FadeLoader css={`${spinner}`} color={"#777"} loading={true} width={4} />}
          </Content>
        : <Disabled>Reports are currently Disabled for this Position.</Disabled>
      : <FadeLoader
      css={`${spinner}`}
      color={"#777"}
      loading={true}
      width={4}
      />}
    </Dialog>
  );
}
